import React, { useEffect, useState } from 'react';

export default function FrozenModal() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handler = () => setVisible(true);
    window.addEventListener('account-frozen', handler);
    return () => window.removeEventListener('account-frozen', handler);
  }, []);

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: 'rgba(0,0,0,0.6)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <div style={{
        background: '#1e293b', borderRadius: '1rem',
        padding: '2.5rem 2rem', maxWidth: 380, width: '90%',
        textAlign: 'center', boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
        border: '1px solid #ef4444',
      }}>
        <div style={{ fontSize: '3rem', marginBottom: '0.75rem' }}>🔒</div>
        <h2 style={{ color: '#ef4444', margin: '0 0 0.75rem', fontSize: '1.25rem' }}>
          Account Suspended
        </h2>
        <p style={{ color: '#cbd5e1', margin: '0 0 1.5rem', lineHeight: 1.6, fontSize: '0.95rem' }}>
          Your account has been frozen by the administrator. You cannot record transactions at this time.
          Please contact admin to resolve this.
        </p>
        <a
          href="mailto:support@getshopbook.com"
          style={{
            display: 'inline-block', background: '#ef4444', color: '#fff',
            padding: '0.65rem 1.5rem', borderRadius: '0.5rem',
            textDecoration: 'none', fontWeight: 600, fontSize: '0.9rem',
          }}
        >
          Contact Admin
        </a>
      </div>
    </div>
  );
}
